import { useMediaQuery } from "@mui/material";
import { usePostHog } from "posthog-js/react";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch } from "react-redux";
import "swiper/css";
import "swiper/css/autoplay";
import { openEmployerSignUp } from "../../../helpers/elp_sign_up";
import { HeightSpacer } from "../../shared/Spacer/styles";
import content_my from "./content_my.json";
import {
  ButtonStyled,
  GridContainerStyled,
  LogoStyled,
  TaglineContainer,
  TaglineSubtitle,
  TaglineTitle,
  TrustedCompanyGrid,
} from "./styles";

const universities = [
  {
    name: "Taylor's University",
    image:
      "https://assets.wobbjobs.com/images/employer_landing/universities/taylors.png",
  },
  {
    name: "Sunway University",
    image:
      "https://assets.wobbjobs.com/images/employer_landing/universities/sunway.png",
  },
  {
    name: "Monash University",
    image:
      "https://assets.wobbjobs.com/images/employer_landing/universities/monash.png",
  },
  {
    name: "Tunku Abdul Rahman University of Management and Technology",
    image:
      "https://assets.wobbjobs.com/images/employer_landing/universities/tarumt.png",
  },
  {
    name: "University Tunku Abdul Rahman",
    image:
      "https://assets.wobbjobs.com/images/employer_landing/universities/utar.png",
  },
  {
    name: "University of Malaya",
    image:
      "https://assets.wobbjobs.com/images/employer_landing/universities/um.png",
  },
  {
    name: "University of Nottingham",
    image:
      "https://assets.wobbjobs.com/images/employer_landing/universities/nottingham.png",
  },
  {
    name: "INTI University",
    image:
      "https://assets.wobbjobs.com/images/employer_landing/universities/inti.png",
  },
];

export default function FreeCarousel() {
  const [solutions, setSolutions] = useState([]);
  const [solutionsDescription, setSolutionsDescription] = useState([]);
  const [solutionsCard, setSolutionsCard] = useState([]);
  const isMobile = useMediaQuery("(max-width:768px)");

  const dispatch = useDispatch();
  const containerRef = useRef(null);

  async function fetchData() {
    const response = content_my;

    const { advantageTitle, advantageSection, advantageSubtitle } =
      response || {};
    setSolutions(advantageTitle);
    setSolutionsDescription(advantageSubtitle);
    setSolutionsCard(advantageSection);
  }

  const buttonCTA = "Claim my free post";
  const buttonColour = "yellow";
  const posthog = usePostHog();

  function triggerInfoDialog() {
    openEmployerSignUp({
      posthog,
      buttonCTA: buttonCTA,
      buttonColour: buttonColour,
      section: "post_for_free_campus",
    });
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <GridContainerStyled id={"solutions-content"} ref={containerRef}>
      <TaglineContainer>
        <TaglineTitle
          dangerouslySetInnerHTML={{ __html: solutions }}
        ></TaglineTitle>

        <TaglineSubtitle
          dangerouslySetInnerHTML={{ __html: solutionsDescription }}
        ></TaglineSubtitle>
        {!isMobile && <HeightSpacer $height={"40px"} />}
      </TaglineContainer>

      <TrustedCompanyGrid
        container
        justifyContent={"center"}
        flexDirection={"column"}
        alignItems={"center"}
      >
        {universities.map((uni, index) => (
          <div key={index}>
            <LogoStyled
              src={uni?.image}
              alt={uni?.name}
              style={{ height: "72px", width: "100%" }}
            />
          </div>
        ))}
      </TrustedCompanyGrid>

      <ButtonStyled onClick={triggerInfoDialog}>{buttonCTA}</ButtonStyled>
    </GridContainerStyled>
  );
}
